import { render, staticRenderFns } from "./subcategory.vue?vue&type=template&id=1c7d95b4&lang=html"
import script from "./subcategory.vue?vue&type=script&lang=js"
export * from "./subcategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports